<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'CardBox1',
})
</script>
<template>
  <div :class="bem([theme])">
    <div :class="bem('hd')">{{ title }}</div>
    <Skeleton :loading="false" active :paragraph="{ rows: 4 }">
      <div :class="bem('bd')">
        <slot />
      </div>
    </Skeleton>
  </div>
</template>

<script lang="ts" setup name="CardBox1">
import { createNamespace } from '@bd/vue3-utils'
import { Skeleton } from 'ant-design-vue'

const [_, bem] = createNamespace('CardBox2')
withDefaults(
  defineProps<{
    title: string
    loading?: boolean
    theme?: 'gray' | 'blue'
  }>(),
  {
    loading: false,
    theme: 'gray'
  }
)
</script>

<style lang="less">
@ns: card-box2;
.@{ns} {
  border-radius: @border-radius-base;
  overflow: hidden;

  &__hd {
    padding: @padding-sm;
  }

  &__bd {
    padding: @padding-sm;
    border: @border-base;
    border-top: none;
    background: @white;
  }

  &--blue {
    .@{ns}__hd {
      background: @bg-fade-1;
    }
  }

  &--gray {
    .@{ns}__hd {
      background: @bg-fade-0;
    }
  }
}
</style>
